import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styled, Tabs } from '@mui/material';
import { pxToRem } from '@themes';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTabs = styled(function (props) {
  return /*#__PURE__*/_jsx(Tabs, _objectSpread({}, props));
}, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'viewVariant';
  }
})(function (_ref) {
  var theme = _ref.theme,
      viewVariant = _ref.viewVariant,
      size = _ref.size;
  var styles = {
    '& .MuiTabs-indicator': {
      backgroundColor: theme.colors.funGreen,
      bottom: pxToRem(10)
    }
  };

  switch (size) {
    case 'small':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          '& .MuiTabs-indicator': {
            bottom: pxToRem(20),
            backgroundColor: theme.colors.funGreen
          }
        });
        break;
      }

    default:
      {
        break;
      }
  }

  switch (viewVariant) {
    case 'contained':
      {
        styles = _objectSpread(_objectSpread({}, styles), {
          '& .MuiTabs-indicator': {
            backgroundColor: 'transparent',
            bottom: '0'
          }
        });
        break;
      }

    default:
      {
        break;
      }
  }

  return styles;
});
export { StyledTabs };